import React from 'react';

const AboutCard = ({ title, content, img }) => {
    return (
        <div className='container m-2 p-2 sm:m-4 sm:p-4'>
            <div>
                <div className='flex flex-wrap flex-col-reverse md:flex-nowrap md:flex-row'>
                    <div className='w-auto pt-2 mr-2 text-center'>
                        <h1 className='text-primary font-bold text-4xl my-2'>
                            {title}
                        </h1>
                        <p>{content}</p>
                        <div className='my-2'>
                            <a
                                href='https://drive.google.com/file/d/1vUKQCJ8EfIvMIV_CrCO6_fQsi5RxKScV/view?usp=sharing'
                                target='_blank'
                                rel='noopener noreferrer'
                                className='inline-flex items-center py-2 px-3 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 '
                            >
                                Resume
                                <svg
                                    className='ml-2 -mr-1 w-4 h-4'
                                    fill='currentColor'
                                    viewBox='0 0 20 20'
                                    xmlns='http://www.w3.org/2000/svg'
                                >
                                    <path
                                        fill-rule='evenodd'
                                        d='M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z'
                                        clip-rule='evenodd'
                                    ></path>
                                </svg>
                            </a>{' '}
                        </div>
                    </div>
                    <div className='md:shrink-0 m-2 p-2 flex justify-center'>
                        <img
                            className='h-48 aspect-square rounded-full object center'
                            src={img}
                            alt=''
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AboutCard;
